import { render } from "./stepsComponent.vue?vue&type=template&id=662b9bb9"
import script from "./stepsComponent.vue?vue&type=script&lang=js"
export * from "./stepsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__